import React, { ChangeEvent, FC } from 'react';
import { TextField } from '@mui/material';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { Button } from 'src/components/Button';
import { Form } from 'src/components/Forms/ResetPasswordForm/styled';
import { useGoogleAnalytics } from 'src/hooks/useGoogleAnalytics';

export interface ResetPasswordFormValues {
  email: string;
}

interface ResetPasswordFormProps {
  onSubmit: SubmitHandler<ResetPasswordFormValues>;
  loading: boolean;
}

export const ResetPasswordForm: FC<ResetPasswordFormProps> = ({
  onSubmit,
  loading,
}) => {
  const { trackFormSubmit, trackFormStart } = useGoogleAnalytics();
  const {
    formState: { errors, isValid },
    register,
    setValue,
    handleSubmit,
  } = useFormContext<ResetPasswordFormValues>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setValue('email', value, { shouldValidate: true });
  };

  const handleFormStart = () => {
    trackFormStart('reset_password', 'auth');
  };

  const handleFormSubmit = (data: ResetPasswordFormValues) => {
    trackFormSubmit('reset_password', 'auth');
    onSubmit(data);
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <TextField
        {...register('email', { onChange: handleChange })}
        label="Email"
        error={!!errors.email}
        helperText={errors.email?.message || ' '}
        onFocus={handleFormStart}
      />
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid}
        loading={loading}
      >
        Reset your password
      </Button>
    </Form>
  );
};
